module.exports = __webpack_public_path__ + "img/hic-genitourinary-diseases-male.9dbc88b7.png";